var _circle, _path, _path2, _ellipse, _ellipse2, _ellipse3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPublishedWork72(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 36,
    fill: "#FFF6E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1696 31.4184H22.0996M24.176 48.0002H49.0932C50.24 48.0002 51.1696 47.0722 51.1696 45.9275V27.2729C51.1696 26.1282 50.24 25.2002 49.0932 25.2002H24.176C23.0293 25.2002 22.0996 26.1282 22.0996 27.2729V45.9275C22.0996 47.0722 23.0293 48.0002 24.176 48.0002Z",
    stroke: "#FF739D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6855 36.6001L35.4434 41.8251L33.0605 39.4501",
    stroke: "#FF739D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.4355,
    cy: 28.5252,
    rx: 0.953115,
    ry: 0.95,
    fill: "#FF739D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.2949,
    cy: 28.5252,
    rx: 0.953115,
    ry: 0.95,
    fill: "#FF739D"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.1543,
    cy: 28.5252,
    rx: 0.953115,
    ry: 0.95,
    fill: "#FF739D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedWork72);
export default __webpack_public_path__ + "static/media/published-work-72.fa559749.svg";
export { ForwardRef as ReactComponent };